
import React, { useState, useEffect, useCallback } from 'react';
import TratoAbi from 'abis/Trato.abi';
import { Contract, providers, Wallet, utils, getDefaultProvider, ContractFactory } from 'ethers'
import { useTranslation } from 'react-i18next';
import { toast } from 'components/Shared/Toast';
import { useMutation, useQueryClient } from 'react-query';
import bootbox from 'components/Modals/Bootbox';
import { transferEth as transferAPI } from 'api/actions/users';
import { getTimeline, clientContractAction, contractAction, } from 'api/actions/contracts';
import { fetcher } from 'api/client';

function useMetamask(address, contractId, pagareId, jwt) {

    const { t } = useTranslation()
    const [pagare, setPagare] = useState(null);
    const queryClient = useQueryClient();
    const [metamask, setMetamask] = useState(false);
    const [provider, setProvider] = useState();
    const [isConnected, setConnected] = useState(false);
    const [stateReconnect, setStateReconnect] = useState();
    const [providerAddress, setProviderAddress] = useState();
    const [wallet, setWallet] = useState();

    const apiCall = jwt ? clientContractAction : contractAction;

    const { mutate: cancelPagareMutation, isLoading: isCanceling } = useMutation((payload) =>
        fetcher(apiCall(contractId, 'cancelpagare', payload), jwt), {
        onError: (error) => {
            toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
        },
        onSuccess: () => {
            toast.success(t('blockchain.successfull_cancel'))
            queryClient.invalidateQueries([contractId, 'blockchain']);
        }
    });

    const { mutateAsync: endorsePagareMutation, isLoading: isEndorsing } = useMutation((payload) =>
        fetcher(apiCall(contractId, 'endorsepagare', payload), jwt));

    const { mutate: transferMutation } = useMutation((payload) => fetcher(transferAPI(payload), jwt));

    const handleAccountsChanged = useCallback((accounts) => {
        setProviderAddress(accounts[0]);
    }, [])

    useEffect(() => {
        async function init() {
            if (!window.ethereum) return setMetamask(false);
            setConnected(true);
            try {
                await window.ethereum.send('eth_requestAccounts');
                const internalProvider = new providers.Web3Provider(window.ethereum);
                const wall = internalProvider.getSigner();
                setProvider(internalProvider);
                setWallet(wall);
                const add = (await internalProvider.listAccounts())[0];
                setProviderAddress(add);
                const addresses = await window.ethereum.request({ method: 'eth_accounts' })
                setProviderAddress(addresses[0]);
                window.ethereum.on('accountsChanged', handleAccountsChanged);
                if (address) {
                    setPagare(new Contract(address, TratoAbi, wall))
                }
                setMetamask(true);
            } catch (e) {
                setMetamask('rejected')
            }
        }
        init();
        return () => {
            // window?.ethereum?.off('accountsChanged');
        }
    }, [address, handleAccountsChanged, stateReconnect])

    const reconnect = () => setStateReconnect(Math.random())

    const mapErrors = (error) => {
        switch (error?.error?.code) {
            case -32603: return toast.error(t('errors.BurnAmountExceedsBalance'));
            case -32000: return toast.error(t('errors.balance_insufficient'))
            default: toast.error(t('errors.metamaskRejected'));
        }
    };

    const endorseToken = async (to) => {
        if (!utils.isAddress(to)) return bootbox.alert(t('errors.InvalidAddress'));
        const confirm = await bootbox.confirm(t('blockchain.confirm_endorse', { replace: to }))
        if (confirm) {
            try {
                const transfer = await pagare.endosar(to, pagareId)
                return endorsePagareMutation({ ...transfer, newOwnerAddress: to })
            } catch (error) {
                mapErrors(error)
            }
        }
    }

    const burnToken = async () => {
        const cancelConfirmation = await bootbox.confirm(t('blockchain.cancel_confirmation'))
        if (cancelConfirmation) {
            try {
                const burn = await pagare.destruir(pagareId)
                return cancelPagareMutation(burn);
            } catch (error) {
                mapErrors(error)
            }
        }
    }

    const transferEth = async (to, value) => {
        try {
            const transaction = await wallet.sendTransaction({
                to,
                value: utils.parseEther(value)
            });
            return transferMutation({ transaction, to, value })
        } catch (error) {
            mapErrors(error)
        }
    }


    return { pagare, metamask, endorseToken, burnToken, isCanceling, isEndorsing, transferEth, wallet, providerAddress, isConnected, reconnect }
}

export default useMetamask;